// source: protobuf/filter/export.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var protobuf_filter_file_pb = require('../../protobuf/filter/file_pb.js');
goog.object.extend(proto, protobuf_filter_file_pb);
goog.exportSymbol('proto.filter.ExportRequest', null, global);
goog.exportSymbol('proto.filter.ExportRequestOptions', null, global);
goog.exportSymbol('proto.filter.ExportResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filter.ExportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.filter.ExportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filter.ExportRequest.displayName = 'proto.filter.ExportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filter.ExportRequestOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.filter.ExportRequestOptions.repeatedFields_, null);
};
goog.inherits(proto.filter.ExportRequestOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filter.ExportRequestOptions.displayName = 'proto.filter.ExportRequestOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filter.ExportResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.filter.ExportResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filter.ExportResponse.displayName = 'proto.filter.ExportResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filter.ExportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.filter.ExportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filter.ExportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filter.ExportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pdf: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    excel: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    word: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    html: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    options: (f = msg.getOptions()) && proto.filter.ExportRequestOptions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filter.ExportRequest}
 */
proto.filter.ExportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filter.ExportRequest;
  return proto.filter.ExportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filter.ExportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filter.ExportRequest}
 */
proto.filter.ExportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPdf(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExcel(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWord(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHtml(value);
      break;
    case 5:
      var value = new proto.filter.ExportRequestOptions;
      reader.readMessage(value,proto.filter.ExportRequestOptions.deserializeBinaryFromReader);
      msg.setOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filter.ExportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filter.ExportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filter.ExportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filter.ExportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPdf();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getExcel();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getWord();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getHtml();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getOptions();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.filter.ExportRequestOptions.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool pdf = 1;
 * @return {boolean}
 */
proto.filter.ExportRequest.prototype.getPdf = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.filter.ExportRequest} returns this
 */
proto.filter.ExportRequest.prototype.setPdf = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool excel = 2;
 * @return {boolean}
 */
proto.filter.ExportRequest.prototype.getExcel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.filter.ExportRequest} returns this
 */
proto.filter.ExportRequest.prototype.setExcel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool word = 3;
 * @return {boolean}
 */
proto.filter.ExportRequest.prototype.getWord = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.filter.ExportRequest} returns this
 */
proto.filter.ExportRequest.prototype.setWord = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool html = 4;
 * @return {boolean}
 */
proto.filter.ExportRequest.prototype.getHtml = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.filter.ExportRequest} returns this
 */
proto.filter.ExportRequest.prototype.setHtml = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional ExportRequestOptions options = 5;
 * @return {?proto.filter.ExportRequestOptions}
 */
proto.filter.ExportRequest.prototype.getOptions = function() {
  return /** @type{?proto.filter.ExportRequestOptions} */ (
    jspb.Message.getWrapperField(this, proto.filter.ExportRequestOptions, 5));
};


/**
 * @param {?proto.filter.ExportRequestOptions|undefined} value
 * @return {!proto.filter.ExportRequest} returns this
*/
proto.filter.ExportRequest.prototype.setOptions = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.filter.ExportRequest} returns this
 */
proto.filter.ExportRequest.prototype.clearOptions = function() {
  return this.setOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filter.ExportRequest.prototype.hasOptions = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.filter.ExportRequestOptions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filter.ExportRequestOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.filter.ExportRequestOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filter.ExportRequestOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filter.ExportRequestOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
    columnsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    maxRows: jspb.Message.getFieldWithDefault(msg, 2, 0),
    maxColumns: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filter.ExportRequestOptions}
 */
proto.filter.ExportRequestOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filter.ExportRequestOptions;
  return proto.filter.ExportRequestOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filter.ExportRequestOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filter.ExportRequestOptions}
 */
proto.filter.ExportRequestOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addColumns(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxRows(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxColumns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filter.ExportRequestOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filter.ExportRequestOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filter.ExportRequestOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filter.ExportRequestOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColumnsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getMaxRows();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getMaxColumns();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * repeated string columns = 1;
 * @return {!Array<string>}
 */
proto.filter.ExportRequestOptions.prototype.getColumnsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.filter.ExportRequestOptions} returns this
 */
proto.filter.ExportRequestOptions.prototype.setColumnsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.filter.ExportRequestOptions} returns this
 */
proto.filter.ExportRequestOptions.prototype.addColumns = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.filter.ExportRequestOptions} returns this
 */
proto.filter.ExportRequestOptions.prototype.clearColumnsList = function() {
  return this.setColumnsList([]);
};


/**
 * optional int64 max_rows = 2;
 * @return {number}
 */
proto.filter.ExportRequestOptions.prototype.getMaxRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.filter.ExportRequestOptions} returns this
 */
proto.filter.ExportRequestOptions.prototype.setMaxRows = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 max_columns = 3;
 * @return {number}
 */
proto.filter.ExportRequestOptions.prototype.getMaxColumns = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.filter.ExportRequestOptions} returns this
 */
proto.filter.ExportRequestOptions.prototype.setMaxColumns = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filter.ExportResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.filter.ExportResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filter.ExportResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filter.ExportResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pdf: (f = msg.getPdf()) && protobuf_filter_file_pb.FileDescription.toObject(includeInstance, f),
    excel: (f = msg.getExcel()) && protobuf_filter_file_pb.FileDescription.toObject(includeInstance, f),
    word: (f = msg.getWord()) && protobuf_filter_file_pb.FileDescription.toObject(includeInstance, f),
    html: (f = msg.getHtml()) && protobuf_filter_file_pb.FileDescription.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filter.ExportResponse}
 */
proto.filter.ExportResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filter.ExportResponse;
  return proto.filter.ExportResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filter.ExportResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filter.ExportResponse}
 */
proto.filter.ExportResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new protobuf_filter_file_pb.FileDescription;
      reader.readMessage(value,protobuf_filter_file_pb.FileDescription.deserializeBinaryFromReader);
      msg.setPdf(value);
      break;
    case 2:
      var value = new protobuf_filter_file_pb.FileDescription;
      reader.readMessage(value,protobuf_filter_file_pb.FileDescription.deserializeBinaryFromReader);
      msg.setExcel(value);
      break;
    case 3:
      var value = new protobuf_filter_file_pb.FileDescription;
      reader.readMessage(value,protobuf_filter_file_pb.FileDescription.deserializeBinaryFromReader);
      msg.setWord(value);
      break;
    case 4:
      var value = new protobuf_filter_file_pb.FileDescription;
      reader.readMessage(value,protobuf_filter_file_pb.FileDescription.deserializeBinaryFromReader);
      msg.setHtml(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filter.ExportResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filter.ExportResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filter.ExportResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filter.ExportResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPdf();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      protobuf_filter_file_pb.FileDescription.serializeBinaryToWriter
    );
  }
  f = message.getExcel();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      protobuf_filter_file_pb.FileDescription.serializeBinaryToWriter
    );
  }
  f = message.getWord();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      protobuf_filter_file_pb.FileDescription.serializeBinaryToWriter
    );
  }
  f = message.getHtml();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      protobuf_filter_file_pb.FileDescription.serializeBinaryToWriter
    );
  }
};


/**
 * optional FileDescription pdf = 1;
 * @return {?proto.filter.FileDescription}
 */
proto.filter.ExportResponse.prototype.getPdf = function() {
  return /** @type{?proto.filter.FileDescription} */ (
    jspb.Message.getWrapperField(this, protobuf_filter_file_pb.FileDescription, 1));
};


/**
 * @param {?proto.filter.FileDescription|undefined} value
 * @return {!proto.filter.ExportResponse} returns this
*/
proto.filter.ExportResponse.prototype.setPdf = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.filter.ExportResponse} returns this
 */
proto.filter.ExportResponse.prototype.clearPdf = function() {
  return this.setPdf(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filter.ExportResponse.prototype.hasPdf = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FileDescription excel = 2;
 * @return {?proto.filter.FileDescription}
 */
proto.filter.ExportResponse.prototype.getExcel = function() {
  return /** @type{?proto.filter.FileDescription} */ (
    jspb.Message.getWrapperField(this, protobuf_filter_file_pb.FileDescription, 2));
};


/**
 * @param {?proto.filter.FileDescription|undefined} value
 * @return {!proto.filter.ExportResponse} returns this
*/
proto.filter.ExportResponse.prototype.setExcel = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.filter.ExportResponse} returns this
 */
proto.filter.ExportResponse.prototype.clearExcel = function() {
  return this.setExcel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filter.ExportResponse.prototype.hasExcel = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional FileDescription word = 3;
 * @return {?proto.filter.FileDescription}
 */
proto.filter.ExportResponse.prototype.getWord = function() {
  return /** @type{?proto.filter.FileDescription} */ (
    jspb.Message.getWrapperField(this, protobuf_filter_file_pb.FileDescription, 3));
};


/**
 * @param {?proto.filter.FileDescription|undefined} value
 * @return {!proto.filter.ExportResponse} returns this
*/
proto.filter.ExportResponse.prototype.setWord = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.filter.ExportResponse} returns this
 */
proto.filter.ExportResponse.prototype.clearWord = function() {
  return this.setWord(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filter.ExportResponse.prototype.hasWord = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional FileDescription html = 4;
 * @return {?proto.filter.FileDescription}
 */
proto.filter.ExportResponse.prototype.getHtml = function() {
  return /** @type{?proto.filter.FileDescription} */ (
    jspb.Message.getWrapperField(this, protobuf_filter_file_pb.FileDescription, 4));
};


/**
 * @param {?proto.filter.FileDescription|undefined} value
 * @return {!proto.filter.ExportResponse} returns this
*/
proto.filter.ExportResponse.prototype.setHtml = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.filter.ExportResponse} returns this
 */
proto.filter.ExportResponse.prototype.clearHtml = function() {
  return this.setHtml(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filter.ExportResponse.prototype.hasHtml = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.filter);
